import type { CustomPageSidebar } from '~/types/adminApi';

export const customPageSidebar: CustomPageSidebar = {
    title: 'Custom Page',
    description: 'This is a custom page sidebar',
};
